import React from 'react';
import { format } from 'date-fns';
import { Notification } from '../lib/supabase';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';
import clsx from 'clsx';

interface NotificationsDropdownProps {
  notifications: Notification[];
  onClose: () => void;
  onMarkAsRead: () => void;
}

export default function NotificationsDropdown({
  notifications,
  onClose,
  onMarkAsRead,
}: NotificationsDropdownProps) {
  async function handleMarkAsRead(notificationId: string) {
    try {
      const { error } = await supabase
        .from('notifications')
        .update({ read: true })
        .eq('id', notificationId);

      if (error) throw error;
      
      onMarkAsRead();
      toast.success('Notification marked as read');
    } catch (error) {
      console.error('Error marking notification as read:', error);
      toast.error('Failed to mark notification as read');
    }
  }

  return (
    <div className={clsx(
      "bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50",
      "fixed inset-x-4 top-16 sm:absolute sm:right-0 sm:top-auto sm:mt-2 sm:w-80 sm:inset-auto"
    )}>
      <div className="py-2">
        <div className="px-4 py-2 border-b border-gray-100">
          <h3 className="text-sm font-medium text-gray-900">Notifications</h3>
        </div>
        <div className="max-h-[60vh] sm:max-h-96 overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="px-4 py-3 text-sm text-gray-500">
              No new notifications
            </div>
          ) : (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className="px-4 py-3 hover:bg-gray-50 cursor-pointer"
                onClick={() => handleMarkAsRead(notification.id)}
              >
                <div className="text-sm text-gray-900">
                  {notification.type === 'created' && 'A new entry was added'}
                  {notification.type === 'updated' && 'An entry was updated'}
                  {notification.type === 'deleted' && 'An entry was deleted'}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  {format(new Date(notification.created_at), 'MMM d, yyyy h:mm a')}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}